import { SWITCH_COMPANY_SUCCESSFUL } from '@reduxLocal/actions/types';
import { store } from '@reduxLocal/persistState';

type SessionTargetUser = {
	_id?: string;
	id?: string;
	email?: string;
	name?: string;
	surname?: string;
	avatar?: string;
	profile_information?: {
		name?: string;
		surname?: string;
		avatar?: string;
	};
};

/**
 * Hydrate Redux after session probe reports target-user context.
 * Keeps authenticated user id; stores target user separately for data scope.
 */
export function applyTargetUserSessionContext(sessionData: {
	userId?: string;
	targetUserId?: string | null;
	targetUser?: SessionTargetUser | null;
}): void {
	if (!sessionData?.targetUser) return;

	const targetUserId =
		sessionData.targetUserId ||
		sessionData.targetUser._id ||
		sessionData.targetUser.id;
	if (!targetUserId) return;

	const profile = sessionData.targetUser.profile_information;
	const targetUser = {
		_id: targetUserId,
		email: sessionData.targetUser.email,
		name: sessionData.targetUser.name ?? profile?.name,
		surname: sessionData.targetUser.surname ?? profile?.surname,
		avatar:
			sessionData.targetUser.avatar ??
			profile?.avatar?.img ??
			profile?.avatar,
	};

	store.dispatch({
		type: SWITCH_COMPANY_SUCCESSFUL,
		payload: {
			switchType: 'user',
			originalUserId: sessionData.userId,
			targetUserId,
			targetUser,
		},
	});
}
